<div class="slider" [class.hideBar]="!showBar">
  <div class="line"></div>
  <div class="subline inc"></div>
  <div class="subline dec"></div>
</div>
